export const GET_CUSTOMER_BASEINFO = 'GET_CUSTOMER_BASEINFO';